import { render, staticRenderFns } from "./apro_recha_campania.vue?vue&type=template&id=5275f0d2"
import script from "./apro_recha_campania.vue?vue&type=script&lang=js"
export * from "./apro_recha_campania.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports